import type { BreadcrumbItem } from './types';

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  onNavigate?: (path: string) => void;
  ariaLabel?: string;
}

export function Breadcrumb({ items, onNavigate, ariaLabel }: BreadcrumbProps) {
  if (items.length === 0) return null;

  return (
    <nav aria-label={ariaLabel ?? '현재 위치'} style={{ display: 'flex', alignItems: 'center', gap: 'var(--spacing-1)' }}>
      {items.map((item, idx) => {
        const isLast = idx === items.length - 1;
        return (
          <span
            key={idx}
            style={{ display: 'flex', alignItems: 'center', gap: 'var(--spacing-1)' }}
          >
            {idx > 0 && (
              <span
                aria-hidden="true"
                style={{
                  color: 'var(--color-text-muted)',
                  fontSize: 'var(--font-size-xs)',
                }}
              >
                /
              </span>
            )}
            {isLast || !item.path ? (
              <span
                aria-current={isLast ? 'page' : undefined}
                style={{
                  fontSize: 'var(--font-size-sm)',
                  color: isLast
                    ? 'var(--color-text-primary)'
                    : 'var(--color-text-secondary)',
                  fontWeight: isLast ? 500 : 400,
                }}
              >
                {item.label}
              </span>
            ) : (
              <button
                type="button"
                onClick={() => onNavigate?.(item.path!)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') onNavigate?.(item.path!);
                }}
                style={{
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  cursor: 'pointer',
                  fontSize: 'var(--font-size-sm)',
                  color: 'var(--color-text-secondary)',
                  textDecoration: 'none',
                }}
              >
                {item.label}
              </button>
            )}
          </span>
        );
      })}
    </nav>
  );
}
